import PropTypes from "prop-types";
import React, { Component } from "react";

import { Row, Label, Col, Card, CardBody, Container } from "reactstrap";

// Redux
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";


import { documentTitleChange } from "components/Utils/utils";
import LanguageDropdown from "components/Common/LanguageDropdown";

class HostedPaymentFail3d extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderId: ""
    };
  }

  componentDidMount() {
    let orderId = this.getQueryStringParameter("orderId");
    this.setState({ orderId: orderId });
  }

  getQueryStringParameter = (name) => {
    const url = window.location.href;
    const regex = new RegExp('[?&]' + name + '=([^&#]*)', 'i');
    const match = regex.exec(url);
    return match ? decodeURIComponent(match[1]) : null;
  }

  render() { 
    return (
      <React.Fragment>
        <Container>
          <Row className="justify-content-center" >

            <Card className="overflow-hidden" style={{ border: '2px solid rgba(0, 0, 0, 0.08)', borderRadius: '8px' }}>
              <CardBody className="pt-1">
                <div style={{ textAlign: 'right', display: 'flex', justifyContent: 'right', }}><LanguageDropdown /></div>
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Card className="overflow-hidden" style={{ marginTop: '5px' }}>
                    <div style={{ border: '0.5px solid rgba(0, 0, 0, 0.08)', borderRadius: '8px' }}>
                      <div className="p-2" style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                        <div>
                          <h4 style={{ color: "black" }}>
                            <i className="bx bx-error-circle" style={{ "marginTop": "-4px", fontSize: "14em", color: "purple", textAlign: 'center', display: 'flex', justifyContent: 'center' }} />
                            <br></br> 
                          </h4>
                          <h5 style={{ color: "black" }}> <br></br><strong>{this.props.t("morparaLinkPaymentFail3dTry").format(this.state.orderId)}</strong></h5>
                        </div>
                      </div>
                    </div>
                  </Card>
                </Col>
              </CardBody>
              <div className="mt-5 text-center">
                <p><strong>© {new Date().getFullYear()} Morpara</strong></p>
              </div>
            </Card>
          </Row>
        </Container>

      </React.Fragment>
    );
  }
}

HostedPaymentFail3d.propTypes = {

  t: PropTypes.any,
};


export default connect(
)(withTranslation()(HostedPaymentFail3d));
